export enum IActivityActionsEnum {
	DELETE = 'delete',
	COMPLETE = 'complete',
	EXTEND = 'extend',
	EDIT = 'edit',
	START = 'start',
	PUSH = 'push',
}
